import React, { useState } from "react";
import { useMutation } from "@apollo/client";
//import bcrypt from "bcryptjs";
import { CREATE_COMMENT, FIND_COMMENTS_BY_SECTION } from "../queries";

import { useParams } from "react-router-dom";
import { TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}

*/
import ReCAPTCHA from "react-google-recaptcha";
/* eslint-disable react/prop-types */
const CommentForm = ({ setError }) => {
  // eslint-disable-next-line;
  //const [t, i18n] = useTranslation("common");
  let sectionss = useParams().id;
  const [t] = useTranslation("common");
  const [commenttext, setText] = useState("");
  const [commentdatetime, setDate] = useState("");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  const [createComment] = useMutation(CREATE_COMMENT, {
    refetchQueries: [{ query: FIND_COMMENTS_BY_SECTION }],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setDate(pvm.toString());
    setText(event);
  };
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  const submit = async (event) => {
    event.preventDefault();
    createComment({
      variables: {
        commenttext,
        commentdatetime,
        sectionid: sectionss,
        userid: localStorage.getItem("id"),
      },
    });
    setText("");
    setDate("");
    setSubmitted(true);
  };
  if (submitted) {
    return (
      <div>
        <h2>{t("headers.commentsandinformation")}</h2>
        {t("common.formok")}
        <br />
      </div>
    );
  } else {
    return (
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>{t("headers.commentsandinformation")}</h2>
              <form onSubmit={submit}>
                <div>
                  {t("common.comment")}
                  <TextField value={commenttext} onChange={({ target }) => uusi(target.value)} />
                </div>
                <br />
                <br />
                <div>
                  <ReCAPTCHA
                    sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                    onChange={onChange}
                  />
                </div>
                <br />
                <br />
                <Button
                  style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                  type="submit"
                  disabled={!verified}
                  executing={executing}
                  submitted={submitted}
                >
                  {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
                </Button>
                <br />
                <br />
              </form>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    );
  }
};

export default CommentForm;
